import * as React from 'react';
import styled from 'styled-components';

import { AquaTheme as T } from '../AquaTheme';
import { AquaMapControl } from './AquaMapControl';

interface IProps {
  /** @ignore */
  className?: string;
  /** One or more AquaMapButtons. */
  children?: React.ReactNode;
  /** Horizontal position. A negative value is an offset from the right. */
  x?: number;
  /** Vertical position. A negative value is an offset from the bottom. */
  y?: number;
}

/**
 * Stacks map buttons vertically into a single bar with separators. Port of
 * AquaUI's MapButtonGroup.
 */
const AquaMapButtonGroupBase = (props: IProps) =>
  <AquaMapControl x={props.x} y={props.y}>
    <div className={props.className} role="group">
      {React.Children.map(props.children, (child: any) =>
        child == null ? null : React.cloneElement(child, { grouped: true }))}
    </div>
  </AquaMapControl>

const AquaMapButtonGroup = styled(AquaMapButtonGroupBase)`
  display: flex;
  flex-direction: column;
  border-radius: 4px;
  box-shadow: ${T.shadows.small};

  & > *:not(:last-child) {
    border-bottom: solid 1px ${T.colors.neutral[80]};
  }
  & > *:not(:first-child) .face {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  & > *:not(:last-child) .face {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
`

export { AquaMapButtonGroup }
